<template>
  <v-menu :close-on-content-click="false" v-model="menu">
    <template  #activator="{ on }">
      <v-btn style="height: 14px"  color="blue"   v-on="on" class="mb-2 white--text text-none" x-small>Filters</v-btn>
    </template>
      <v-list>
        <v-card elevation="0" width="350">
          <v-row>
            <v-col md="12" v-if="unconfirmedBookingsEnabled">
              <v-checkbox
                v-model="includeUnconfirmedBookings"
                label="Include Unconfirmed Bookings"
                hide-details
              ></v-checkbox>
              <v-divider class="px-3 mt-3"></v-divider>
            </v-col>
            <v-col md="12">
              <CustomerSearchFilter :customer="customerId + ''" @customerSelected="customerSelected"></CustomerSearchFilter>
              <v-divider class="px-3 mt-3 mb-3"></v-divider>
            </v-col>
            <v-col md="12">
              <label class="cmr-book-form-label">Select Booking Types</label>
              <v-btn-toggle
                v-model="selectedItems"
                color="primary"
                dense
                group
                multiple
                
              >
                <v-row dense>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'phone'"
                      text
                    >
                      <v-icon x-small class="small-icon">local_phone</v-icon>
                      Phone
                    </v-btn>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'app'"
                      text
                    >
                      <v-icon x-small class="small-icon">smartphone</v-icon>
                      App
                    </v-btn>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'website'"
                      text
                    >
                      <v-icon x-small class="small-icon">desktop_mac</v-icon>
                      web
                    </v-btn>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'repeat'"
                      text
                    >
                      <v-icon x-small class="small-icon">repeat</v-icon>
                      Repeat
                    </v-btn>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'kiosk'"
                      text
                    >
                      <v-icon x-small class="small-icon">storefront</v-icon>
                      Kiosk
                    </v-btn>
                  </v-col>
                  <v-col md="4">
                    <v-btn
                      color="primary"
                      x-small
                      :value="'flag_down'"
                      text
                    >
                      <v-icon x-small class="small-icon">emoji_people</v-icon>
                      Flag Down
                    </v-btn>
                  </v-col>
                </v-row>
  
              </v-btn-toggle>
            </v-col>
          </v-row>
            <v-row v-if="customerId || bookingTypesFilter" class="mt-2">
                <v-col cols="12">
                    <v-divider></v-divider>
                    <v-chip class="white--text mx-1" color="green" small v-if="bookingTypesFilter">
                        <v-icon small>mdi-check</v-icon>
                        <p>Booking Types: {{bookingTypesFilter}}</p>
                    </v-chip>
                    <v-chip class="white--text mx-1"  color="green" small v-if="customerId">
                        <v-icon small>mdi-check</v-icon>
                        <p>Customer ID: {{customerId}}</p>
                    </v-chip>
                </v-col>
            </v-row>
          <v-card-actions class="mt-2">
            <v-spacer></v-spacer>
            <v-btn
              small
              variant="text"
              @click="resetFilters"
            >
              Reset
            </v-btn>
            <v-btn
              small
              color="primary"
              variant="text"
              @click="applyFilters"
            >
              Apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-list>
  </v-menu>
</template>

<script>
import CustomerSearchFilter from '@/components/overwatch/filters/CustomerSearchFilter'
export default {
  name: 'OverwatchFilterPopOver',
  components: {CustomerSearchFilter},
  data() {
    return {
      toggle_exclusive: 2,
      toggle_multiple: [1, 2, 3],
      popover: false,
      checkbox: false,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      search: '',
      bookingTypes: ["Repeat", "Phone", "App", "Website"],
      selectedItems: [],
      includeUnconfirmedBookings: true,
      customerId: '',
      updateCount: 0
    }
  },
  computed: {
    authEmail () {
      return localStorage.getItem('auth_email')
    },
    authUser () {
      return this.$store.getters['getAuthUser']
    },
    isDebbie () {
      if (!this.authEmail) {
          return false;
      }
      return this.authEmail.includes('debbie')
    },
    dispatchConfiguration () {
      return this.$store.getters['dispatch/getDispatchConfiguration']
    },
    unconfirmedBookingsConfig () {
      return (this.dispatchConfiguration ? this.dispatchConfiguration.unconfirmed_booking_configuration : null)
    },
    unconfirmedBookingsEnabled () {
      return (this.unconfirmedBookingsConfig != null ? this.unconfirmedBookingsConfig.enabled : false)
    },
    bookingTypesFilter () {
      return this.$store.getters['overwatch/getBookingTypesFilter']
    },
    customerIdFilter () {
      return this.$store.getters['overwatch/getCustomerIdFilter']
    },
  },
  watch: {
    // authUser () {
    //     if (!this.updateCount) {
    //         this.applyRepeatFilterByDefaultForDebbie()
    //         this.updateCount++
    //     }
    // },
    unconfirmedBookingsConfig() {
      if (this.unconfirmedBookingsConfig != null) {
        if (this.unconfirmedBookingsEnabled) {
          this.includeUnconfirmedBookings = true
          this.$store.commit('overwatch/setIncludeUnconfirmedBookings', this.includeUnconfirmedBookings)
        } else {
          this.includeUnconfirmedBookings = false
          this.$store.commit('overwatch/setIncludeUnconfirmedBookings', this.includeUnconfirmedBookings)
        }
      }
    }
  },
  methods: {
    customerSelected(id) {
      this.customerId = id
    },
    updateSelectedItems(type) {
      if (this.selectedItems.includes(type)) {
        const index = this.selectedItems.indexOf(type);
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(type);
      }
    },
    applyFilters(hideMenu = true) {
      this.$store.commit('overwatch/setIncludeUnconfirmedBookings', this.includeUnconfirmedBookings)
      this.$store.commit('overwatch/setBookingTypesFilter', this.selectedItems.join())
      this.$store.commit('overwatch/setCustomerIdFilter', this.customerId)
        if (hideMenu) {
            this.menu = false
        }
    },
    resetFilters() {
      this.customerId = ''
      this.$store.commit('overwatch/setCustomerIdFilter', this.customerId)
      this.selectedItems = []
      // this.includeUnconfirmedBookings = false
      // this.$store.commit('overwatch/setIncludeUnconfirmedBookings', false)
      this.$store.commit('overwatch/setBookingTypesFilter', '')
      this.$store.commit('overwatch/setCustomerIdFilter', '')
      this.menu = false
    },
      async applyRepeatFilterByDefaultForDebbie () {
        if (this.isDebbie) {
            await this.selectedItems.push('repeat')
            await this.applyFilters(false)
        }
      }
  },
  async mounted() {
    if (this.unconfirmedBookingsConfig != null) {
      if (this.unconfirmedBookingsEnabled) {
        this.includeUnconfirmedBookings = true
      await  this.$store.commit('overwatch/setIncludeUnconfirmedBookings', this.includeUnconfirmedBookings)
      } else {
        this.includeUnconfirmedBookings = false
       await this.$store.commit('overwatch/setIncludeUnconfirmedBookings', this.includeUnconfirmedBookings)
      }
    }
    // this.applyRepeatFilterByDefaultForDebbie()
  }
}
</script>